import React from "react";
import { useTranslation } from "react-i18next";
import { Modal, ModalFooter } from "@vds/modals";
import { Body, Title } from "@vds/typography";
import styled from "styled-components";
import { MarginSpacerXL, MarginSpacerM, MarginSpacerS } from "common/components/styleTag";
import { UnorderedList, ListItem } from "@vds/lists";
import { Button, TextLink } from '@vds/buttons';
import { useMediaQuery } from "react-responsive";


const StyledModal = styled(Modal)`
 font-family: 'Verizon NHG eDS';
 `

const DeviceLockingModal = ({ opened, onOpenedChange, setOpenDeviceLockModal, ...props }) => {
  const { t } = useTranslation(["pdp"]);
  const modalLockListItems = t("device-pdp.deviceLockContent.modalLockListItems", { ns: "pdp", returnObjects: true })
  const isMobile = useMediaQuery({
    query: "(max-width: 545px)",
  });

  return (
    <StyledModal
      ariaLabel=""
      opened={opened}
      onOpenedChange={onOpenedChange}
      disableFocusLock={true}
    >
      <StyledSpan isMobile={isMobile}>
      <Title bold size="large">
        {t("device-pdp.deviceLockContent.modalLockHeading")}
      </Title>
      <MarginSpacerXL />
      <Body bold size="large"
      >
        {t("device-pdp.deviceLockContent.modalLockSubheading")}
      </Body>
      <Body size="large"
      >
        {t("device-pdp.deviceLockContent.modalLockContent")}
      </Body>
      <Body size="large"
      >
        {t("device-pdp.deviceLockContent.modalLockContent-1")}
      </Body>
      <MarginSpacerM />
      <UnorderedList>
        {modalLockListItems?.map((item) =>
        (<ListItem
          size="bodyLarge"
        >
          {item}
        </ListItem>
        ))}
      </UnorderedList>
      <MarginSpacerXL />
      <Body size="large">
        {t("device-pdp.deviceLockContent.modalUnlockContent")}
        <StyledTextLink
         target="_blank"
         href={t("device-pdp.deviceLockContent.modalUnlockingPolicyURL", {
          ns: "pdp",
        })}
         data-track={t("device-pdp.deviceLockContent.modalUnlockingURL", {ns: "pdp",})}
       >
       {t("device-pdp.deviceLockContent.modalUnlockingPolicy", {
          ns: "pdp",
        })}
      </StyledTextLink>
      </Body>
        </StyledSpan>
      <ModalFooter
      >
        <Button use="primary" data-track={t('device-pdp.deviceLockContent.ok', { ns: 'pdp' })} width={isMobile ? "100%" : "18%"} onClick={() => setOpenDeviceLockModal(false)}>{t('device-pdp.deviceLockContent.ok', { ns: 'pdp' })}</Button>
      </ModalFooter>

    </StyledModal>
  );
};

const StyledSpan = styled.span`
${({isMobile}) => isMobile && `
width:75%;

`}`

export const StyledTextLink = styled(TextLink)`
font-size: 16px;
color: #0052cc;
`;


export default DeviceLockingModal;
